import { defineStore } from "pinia";
import { computed, ref } from "vue";

import type { Ref } from "vue";
import { IPersonState, IUserStep } from "../repositories/dto/user/IPersonState.ts";

export enum OnboardingLegalType {
  personal = "personal",
  business = "business",
}

function getOnboardingStepFromString(type: string): OnboardingStep | null {
  for (const step of Object.values(OnboardingStep)) {
    if (step.toString() === type) {
      return step;
    }
  }

  return null;
}

export enum OnboardingStep {
  DONE = "DONE",

  LEGAL_TYPE = "LEGAL_TYPE",

  EMAIL_PASSWORD = "EMAIL_PASSWORD",
  EMAIL_VERIFY = "EMAIL_VERIFY",

  PHONE = "PHONE",
  PHONE_VERIFY = "PHONE_VERIFY",

  APPLICATION_PERSONAL = "APPLICATION_PERSONAL",
  APPLICATION_COMPANY = "APPLICATION_COMPANY",
  APPLICATION_COMPANY_QUESTIONNAIRE = "APPLICATION_COMPANY_QUESTIONNAIRE",
  APPLICATION_COMPANY_OWNERS = "APPLICATION_COMPANY_OWNERS",
  APPLICATION_PERSONAL_QUESTIONNAIRE = "APPLICATION_PERSONAL_QUESTIONNAIRE",
}

export type OnboardingStoreState = {
  legalType: Ref<OnboardingLegalType>;
  steps: Ref<OnboardingStep[]>;
  currentStep: Ref<OnboardingStep>;
};

export const useOnboardingStore = defineStore("onboarding", () => {
  // State
  const state: OnboardingStoreState = {
    legalType: ref(OnboardingLegalType.personal),
    steps: ref([]),
    currentStep: ref(OnboardingStep.DONE)
  };

  // Getters
  const getters = {
    getSteps: computed(() => state.steps),
    getCurrentStep: computed(() => state.currentStep),
    getCurrentStepIdx: computed(() =>
      state.steps.value.indexOf(state.currentStep.value)
    )
  };

  // Actions
  function loadState(userState: IPersonState) {
    state.steps.value = userState.steps
      .map((step: IUserStep) => getOnboardingStepFromString(step.key))
      .filter((step: OnboardingStep | null) => step) as OnboardingStep[];
    if (userState.currentStep) {
      state.currentStep.value =
        getOnboardingStepFromString(userState.currentStep) ??
        OnboardingStep.LEGAL_TYPE;
    }
  }

  return {
    // State
    ...state,

    // Getters
    ...getters,

    loadState
  };
});

export default useOnboardingStore;
